"use client";

import { useEffect, useState } from "react";
import { Button } from "@mantine/core";
import PrivilegeGroupTable from "../components/PrivilegeGroupTable";
import PrivilegeGroupDetailModal from "./privilege-group-detail-modal";
import PrivilegeGroupAssignModal from "./privilege-group-assign-modal";
import { PrivilegeService } from "../services/privilege-service";
import { PrivilegeGroup } from "../types/privilege-types";
import { showToast } from "../../../components/custom/custom-toast";

export default function PrivilegeGroupIndexPage() {
  const { fetch: fetchGroups, response } = PrivilegeService.listGroups();
  const { fetch: deleteGroup } = PrivilegeService.deleteGroup();

  const [openModal, setOpenModal] = useState(false);
  const [openAssign, setOpenAssign] = useState(false);
  const [editId, setEditId] = useState<number | undefined>(undefined);
  const [assignId, setAssignId] = useState<number | undefined>(undefined);

  useEffect(() => {
    fetchGroups();
  }, []);

  const handleDelete = async (group: PrivilegeGroup) => {
    try {
      await deleteGroup({ id: group.id });
      showToast({ message: "Đã xóa nhóm quyền thanh cong", type: "success" });
      fetchGroups();
    } catch (error) {
      showToast({ message: "Không thể xóa nhóm quyền", type: "error" });
    }
  };

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-xl font-bold">Danh sách nhóm quyền</h1>
        <Button
          onClick={() => {
            setEditId(undefined);
            setOpenModal(true);
          }}
        >
          + Tạo nhóm quyền
        </Button>
      </div>

      <PrivilegeGroupTable
        rows={response?.data?.list || []}
        onEdit={(g) => {
          setEditId(g.id);
          setOpenModal(true);
        }}
        onAssign={(g) => {
          setAssignId(g.id);
          setOpenAssign(true);
        }}
        onDelete={handleDelete}
      />

      {/* Modal tạo / cập nhật */}
      {openModal && (
        <PrivilegeGroupDetailModal
          groupId={editId}
          onClose={() => setOpenModal(false)}
          onSaved={() => fetchGroups()}
        />
      )}

      {/* Modal gán user */}
      {openAssign && assignId && (
        <PrivilegeGroupAssignModal
          groupId={assignId}
          onClose={() => setOpenAssign(false)}
          onSuccess={() => fetchGroups()}
        />
      )}
    </div>
  );
}
